import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';

import { TokenService } from '@core/services/token.service';
import { getLanguage } from '@core/utils';

import { APP_PATHS } from '../../app.paths';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn | CanMatchFn = (): boolean => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const tokenService: TokenService = inject(TokenService);

  if (authService.isAuthenticated && !tokenService.isExpireRefreshTime()) {
    return true;
  }
  router.navigate([getLanguage(), APP_PATHS.home]).catch();
  return false;
};
